/* Mouse drag-to-scroll for the fm horizontal rails so desktop customers can
   click-hold and swipe them like the touch experience.

   .fm-sim__track is in the list because it stands in for the theme's
   <slideshow-slides>, which brings its own drag — without this the similar
   posters rail would be the one carousel on the product page you can't drag. */
(function () {
  if (window.__fmDragScroll) return;
  window.__fmDragScroll = true;

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    var scroller = event.target instanceof Element && event.target.closest('.fm-scroller, .fm-sim__track');
    if (!scroller || scroller.scrollWidth <= scroller.clientWidth + 1) return;

    // Stops native image/link dragging and text selection; clicks still fire
    event.preventDefault();

    var startX = event.clientX;
    var startScroll = scroller.scrollLeft;
    var moved = false;

    function onMove(moveEvent) {
      var delta = moveEvent.clientX - startX;
      if (!moved) {
        if (Math.abs(delta) < 4) return;
        moved = true;
        scroller.classList.add('fm-scroller--dragging');
        scroller.style.scrollSnapType = 'none';
        // The similar-posters track scrolls smoothly like the theme's carousel,
        // which under a drag animates towards every intermediate position and
        // lags the pointer.
        scroller.style.scrollBehavior = 'auto';
      }
      scroller.scrollLeft = startScroll - delta;
    }

    function onUp() {
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
      document.removeEventListener('pointercancel', onUp);
      if (!moved) return;
      scroller.classList.remove('fm-scroller--dragging');
      scroller.style.scrollSnapType = '';
      scroller.style.scrollBehavior = '';

      // Swallow the click that fires at the end of a drag so releasing the
      // mouse over a card doesn't open it
      var suppress = function (clickEvent) {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
      };
      document.addEventListener('click', suppress, true);
      setTimeout(function () {
        document.removeEventListener('click', suppress, true);
      }, 0);
    }

    document.addEventListener('pointermove', onMove);
    document.addEventListener('pointerup', onUp);
    document.addEventListener('pointercancel', onUp);
  });
})();
